import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { listDeclarations, uploadJustification } from '../services/assujettiService';

export default function V4DossierPage() {
  const [dossier, setDossier] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [uploadMsg, setUploadMsg] = useState<string | null>(null);
  const fileRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    (async () => {
      try {
        const data = await listDeclarations();
        const list = Array.isArray(data) ? data : [];
        setDossier(list[0] || null);
      } catch (err: any) {
        setError(err.message || 'Erreur de chargement');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  async function handleUpload(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0];
    if (!file || !dossier?.id) return;
    setUploadMsg(null);
    try {
      await uploadJustification(dossier.id, file);
      setUploadMsg('Justification envoyee avec succes.');
    } catch (err: any) {
      setUploadMsg('Erreur: ' + (err.message || 'echec upload'));
    }
    if (fileRef.current) fileRef.current.value = '';
  }

  if (loading) return <div className="p-8 text-center text-gray-500">Chargement...</div>;
  if (error) return <div className="p-8 text-center text-red-600">{error}</div>;
  if (!dossier) return <div className="p-8 text-center text-gray-400">Aucun dossier FPT en cours</div>;

  const variancePct = dossier.variance_pct ?? '--';
  const statusLabel = dossier.payment_allowed ? 'Paiement autorise' : dossier.status || 'En cours';

  const cards = [
    { label: 'Estimation USD', value: `${Number(dossier.estimation_usd || 0).toLocaleString()} USD` },
    { label: 'Declaration USD', value: `${Number(dossier.amount_usd || 0).toLocaleString()} USD` },
    { label: 'Ecart', value: `${variancePct} %` },
    { label: 'Statut', value: statusLabel },
  ];

  return (
    <div className="max-w-5xl mx-auto p-6 space-y-5">
      <div className="bg-white border rounded-xl p-6 shadow-sm">
        <div className="flex justify-between items-start mb-4">
          <div>
            <h3 className="text-lg font-semibold">Mon dossier FPT</h3>
            <p className="text-sm text-gray-500">Estimation, declaration, taxation, paiement et quittance.</p>
          </div>
          <span className="bg-yellow-100 text-yellow-700 text-xs font-bold px-3 py-1 rounded-full">EN COURS</span>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-5">
          {cards.map((c) => (
            <div key={c.label} className="bg-gray-50 border rounded-xl p-4">
              <div className="text-xs text-gray-500 mb-1">{c.label}</div>
              <div className="font-bold">{c.value}</div>
            </div>
          ))}
        </div>

        <div className="bg-yellow-50 border border-yellow-200 text-yellow-800 text-sm rounded-lg p-3 mb-5">
          L'ecart est journalise et transmis au circuit administratif interne. Aucun onglet de controle interne n'est visible dans le portail Assujetti.
        </div>

        {uploadMsg && <div className={`text-sm rounded-lg p-3 mb-3 ${uploadMsg.startsWith('Erreur') ? 'bg-red-50 text-red-700' : 'bg-green-50 text-green-700'}`}>{uploadMsg}</div>}

        <div className="flex flex-wrap gap-2">
          <Link to="/fpt/v4/payments" className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-blue-700">Payer maintenant</Link>
          <button className="border px-4 py-2 rounded-lg text-sm font-semibold hover:bg-gray-50">Telecharger note de debit</button>
          <input ref={fileRef} type="file" accept=".pdf,.jpg,.jpeg,.png" onChange={handleUpload} className="hidden" />
          <button onClick={() => fileRef.current?.click()} className="border px-4 py-2 rounded-lg text-sm font-semibold hover:bg-gray-50">Joindre justification</button>
        </div>
      </div>
    </div>
  );
}
